// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { FitContainer, FitButton } from '../styles/FitSelector.style';

const FitSelector = ({ categoryData, activeCategory, activeFit, onSelectFit }) => (
  <FitContainer className="dynamic-fit-button-section">
    {categoryData.category
      .filter((category) => category.name === activeCategory)
      .map((category) =>
        category.fit.map((fit) => (
          <FitButton
            key={`${fit.name}_fit`}
            id={`${fit.name}_fit_button`}
            className={`${
              activeFit === fit.name ? `active_${fit.name}_fit` : `inactive_${fit.name}_fit`
            }`}
            active={activeFit === fit.name}
            onClick={() => onSelectFit(fit.name)}
          >
            {fit.name}
          </FitButton>
        ))
      )}
  </FitContainer>
);

export default FitSelector;
